import ConstructorIOClient from '@constructor-io/constructorio-client-javascript';
import { useMemo } from 'react';
import version from '../version';
const useCioClient = ({ apiKey, cioClient, options } = {}) => {
    if (!apiKey && !cioClient) {
        throw new Error('Api Key or Constructor Client required');
    }
    const memoizedCioClient = useMemo(() => {
        if (cioClient)
            return cioClient;
        if (apiKey && typeof window !== 'undefined') {
            return new ConstructorIOClient({
                apiKey,
                sendTrackingEvents: true,
                version: `cio-ui-plp-${version}`,
                ...options,
            });
        }
        return null;
    }, [apiKey, cioClient, options]);
    return memoizedCioClient;
};
export default useCioClient;
